!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.as = t());
}(this, function () {
  "use strict";

  return [{
    locale: "as",
    pluralRuleFunction: function (e, t) {
      return t ? 1 == e || 5 == e || 7 == e || 8 == e || 9 == e || 10 == e ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : 6 == e ? "many" : "other" : e >= 0 && e <= 1 ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "বছৰ",
        relative: {
          0: "এই বছৰ",
          1: "অহা বছৰ",
          "-1": "যোৱা বছৰ"
        },
        relativeTime: {
          future: {
            one: "{0} বছৰত",
            other: "{0} বছৰত"
          },
          past: {
            one: "{0} বছৰৰ পূৰ্বে",
            other: "{0} বছৰৰ পূৰ্বে"
          }
        }
      },
      "year-short": {
        displayName: "বছৰ",
        relative: {
          0: "এই বছৰ",
          1: "অহা বছৰ",
          "-1": "যোৱা বছৰ"
        },
        relativeTime: {
          future: {
            one: "{0} বছৰত",
            other: "{0} বছৰত"
          },
          past: {
            one: "{0} বছৰৰ পূৰ্বে",
            other: "{0} বছৰৰ পূৰ্বে"
          }
        }
      },
      month: {
        displayName: "মাহ",
        relative: {
          0: "এই মাহ",
          1: "অহা মাহ",
          "-1": "যোৱা মাহ"
        },
        relativeTime: {
          future: {
            one: "{0} মাহত",
            other: "{0} মাহত"
          },
          past: {
            one: "{0} মাহ পূৰ্বে",
            other: "{0} মাহ পূৰ্বে"
          }
        }
      },
      "month-short": {
        displayName: "মাহ",
        relative: {
          0: "এই মাহ",
          1: "অহা মাহ",
          "-1": "যোৱা মাহ"
        },
        relativeTime: {
          future: {
            one: "{0} মাহত",
            other: "{0} মাহত"
          },
          past: {
            one: "{0} মাহ পূৰ্বে",
            other: "{0} মাহ পূৰ্বে"
          }
        }
      },
      day: {
        displayName: "দিন",
        relative: {
          0: "আজি",
          1: "কাইলৈ",
          2: "পৰহিলৈ",
          "-2": "পৰহি",
          "-1": "কালি"
        },
        relativeTime: {
          future: {
            one: "{0} দিনত",
            other: "{0} দিনত"
          },
          past: {
            one: "{0} দিন পূৰ্বে",
            other: "{0} দিন পূৰ্বে"
          }
        }
      },
      "day-short": {
        displayName: "দিন",
        relative: {
          0: "আজি",
          1: "কাইলৈ",
          2: "পৰহিলৈ",
          "-2": "পৰহি",
          "-1": "কালি"
        },
        relativeTime: {
          future: {
            one: "{0} দিনত",
            other: "{0} দিনত"
          },
          past: {
            one: "{0} দিন পূৰ্বে",
            other: "{0} দিন পূৰ্বে"
          }
        }
      },
      hour: {
        displayName: "ঘণ্টা",
        relative: {
          0: "এইটো ঘণ্টাত"
        },
        relativeTime: {
          future: {
            one: "{0} ঘণ্টাত",
            other: "{0} ঘণ্টাত"
          },
          past: {
            one: "{0} ঘণ্টা পূৰ্বে",
            other: "{0} ঘণ্টা পূৰ্বে"
          }
        }
      },
      "hour-short": {
        displayName: "ঘণ্টা",
        relative: {
          0: "এইটো ঘণ্টাত"
        },
        relativeTime: {
          future: {
            one: "{0} ঘণ্টাত",
            other: "{0} ঘণ্টাত"
          },
          past: {
            one: "{0} ঘণ্টা পূৰ্বে",
            other: "{0} ঘণ্টা পূৰ্বে"
          }
        }
      },
      minute: {
        displayName: "মিনিট",
        relative: {
          0: "এইটো মিনিটত"
        },
        relativeTime: {
          future: {
            one: "{0} মিনিটত",
            other: "{0} মিনিটত"
          },
          past: {
            one: "{0} মিনিট পূৰ্বে",
            other: "{0} মিনিট পূৰ্বে"
          }
        }
      },
      "minute-short": {
        displayName: "মিনিট",
        relative: {
          0: "এইটো মিনিটত"
        },
        relativeTime: {
          future: {
            one: "{0} মিনিটত",
            other: "{0} মিনিটত"
          },
          past: {
            one: "{0} মিনিট পূৰ্বে",
            other: "{0} মিনিট পূৰ্বে"
          }
        }
      },
      second: {
        displayName: "ছেকেণ্ড",
        relative: {
          0: "এতিয়া"
        },
        relativeTime: {
          future: {
            one: "{0} ছেকেণ্ডত",
            other: "{0} ছেকেণ্ডত"
          },
          past: {
            one: "{0} ছেকেণ্ড পূৰ্বে",
            other: "{0} ছেকেণ্ড পূৰ্বে"
          }
        }
      },
      "second-short": {
        displayName: "ছেকেণ্ড",
        relative: {
          0: "এতিয়া"
        },
        relativeTime: {
          future: {
            one: "{0} ছেকেণ্ডত",
            other: "{0} ছেকেণ্ডত"
          },
          past: {
            one: "{0} ছেকেণ্ড পূৰ্বে",
            other: "{0} ছেকেণ্ড পূৰ্বে"
          }
        }
      }
    }
  }];
});